import { Route, Routes } from "react-router";
import "./PlatformSettingsStyles.css";
import AboutComponent from "./About/AboutComponent";
import FeedbackComponent from "./Feedback/FeedbackComponent";
import MySubscriptionComponent from "./MySubscription/MySubscriptionComponent";
import MySubscriptionPlanComponent from "./MySubscription/MySubscriptionPlanComponent";
import OrganizationSidebar from "../my-organization/OrganizationSidebar";

export const PlatformSettings = () => {
  return (
    <>
      <div className="PlatformSettingContentContainer d-flex">
        <OrganizationSidebar pageType="platform" />
        <div className="PlatformSettingRightSideContent">
          <Routes>
            <Route path="/about" element={<AboutComponent />} />
            <Route path="/Feedback" element={<FeedbackComponent />} />
            <Route path="/mysubscription" element={<MySubscriptionComponent />} />
            <Route path="/mysubscription/SubscriptionPlan/:id" element={<MySubscriptionPlanComponent />} />
          </Routes>
        </div>
      </div>

    </>
  );
};
